import { Conditional } from '../../../common';
import cx from 'classnames';
import styles from './style.module.scss';

type Props = {
  label: string;
  value: string;
  required?: boolean;
};

export const ReadonlyValue = ({ label, value, required = true }: Props) => {
  return (
    <div className={styles['read-only-value']}>
      <span className="cat-u-theme-typography-label-lg">{label}</span>
      <Conditional test={required}>
        <span
          className={cx(
            styles['required-field'],
            'cat-u-theme-typography-footnote'
          )}
        >
          {' (required)'}
        </span>
      </Conditional>
      <p className="cat-u-theme-typography-label-lg u-color--ExtraDarkGray mb-0">
        {value}
      </p>
    </div>
  );
};
